/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */

export type ListInterviewInvitesPageSize = typeof ListInterviewInvitesPageSize[keyof typeof ListInterviewInvitesPageSize];


export const ListInterviewInvitesPageSize = {
  NUMBER_10: 10,
  NUMBER_25: 25,
  NUMBER_50: 50,
  NUMBER_100: 100,
} as const;
